var _path, _path2, _path3;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgTicketsOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 11.2589L17.4442 11.2589C16.6358 11.2589 15.979 10.602 15.979 9.79365C15.979 8.98526 16.6358 8.32842 17.4442 8.32842L18 8.32842L18 4L2 4L2 15.5705L18 15.5705L18 11.2589ZM3.11158 5.11152L6.69895 5.11152L6.69895 6.54316L7.81056 6.54316L7.81056 5.11152L16.9053 5.11152L16.9053 7.28409C15.7432 7.53667 14.8843 8.56406 14.8843 9.79359C14.8843 11.023 15.7432 12.0504 16.9053 12.3031L16.9053 14.4589L7.81056 14.4589L7.81056 13.0272L6.69895 13.0272L6.69895 14.4589L3.11158 14.4589L3.11158 5.11152Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.81055 7.625L7.81055 9.25868L6.69894 9.25868L6.69894 7.625L7.81055 7.625Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.81055 10.3359L7.81055 11.9696L6.69894 11.9696L6.69894 10.3359L7.81055 10.3359Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketsOrders);
export default __webpack_public_path__ + "static/media/tickets-orders.482c2b0475a00c1255d91a5df9d4d078.svg";
export { ForwardRef as ReactComponent };